module.exports = __webpack_public_path__ + "img/rwgj.308388d.png";